import { render, staticRenderFns } from "./garden26.vue?vue&type=template&id=e22301f0&scoped=true&"
import script from "./garden26.vue?vue&type=script&lang=js&"
export * from "./garden26.vue?vue&type=script&lang=js&"
import style0 from "./garden26.vue?vue&type=style&index=0&id=e22301f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22301f0",
  null
  
)

export default component.exports